import React, { useState, useEffect } from 'react';
import Header from '../../master/SideBar';
import Nav from '../../master/NavBar';
import Footer from '../footer';

const students = [
    { id: 1, name: 'Aman Kumar', dob: '2025-07-13' },
    { id: 2, name: 'Priya Singh', dob: '2025-07-13' },
    { id: 3, name: 'Rahul Verma', dob: '2025-07-13' },
    { id: 4, name: 'Sneha Sharma', dob: '2025-07-13' },
    { id: 5, name: 'Ravi Yadav', dob: '2025-07-13' },
    { id: 6, name: 'Meera Joshi', dob: '2025-07-13' },
    { id: 7, name: 'Vijay Patil', dob: '2025-07-13' },
    // add more as needed
];

const formatMD = (str) => {
    const d = new Date(str);
    return `${d.getMonth() + 1}-${d.getDate()}`;
};

export default function BirthdayCard() {
    const [todayList, setTodayList] = useState([]);
    const [upcomingList, setUpcomingList] = useState([]);

    useEffect(() => {
        const now = new Date();
        const todayMD = formatMD(now.toISOString());

        const upcomingEnd = new Date(now);
        upcomingEnd.setDate(now.getDate() + 7);

        const today = [];
        const upcoming = [];

        students.forEach((s) => {
            const md = formatMD(s.dob);
            const thisYearBirthday = new Date(`${now.getFullYear()}-${md}`);

            if (md === todayMD) {
                today.push(s);
            } else if (thisYearBirthday > now && thisYearBirthday <= upcomingEnd) {
                upcoming.push(s);
            }
        });

        // Sort by date
        upcoming.sort((a, b) => new Date(`${new Date().getFullYear()}-${formatMD(a.dob)}`) - new Date(`${new Date().getFullYear()}-${formatMD(b.dob)}`));

        setTodayList(today);
        setUpcomingList(upcoming.slice(0, 5)); // Limit to 5
    }, []);

    const genMessage = (name) => `🎉 Happy Birthday, ${name}! Warm wishes from Adarsh Vidya Mandir!`;

    return (
        <>
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-fluid  py-4">

                                <div className="card p-4 mb-4">
                                    {/* Heading */}
                                    <div className="mb-4">
                                        <h3 className="fw-bold text-primary"> Student Birthdays</h3>
                                    </div>

                                    <div className="row g-4 mb-5">
                                        {todayList.map((s) => (
                                            <div className="col-md-4" key={s.id}>
                                                <div className="card border-0 shadow rounded-4 bg-white p-3">
                                                    <div className="position-relative">
                                                        <img
                                                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTx7u7eRJp38kyx4MXXTEHhuqmFUyP5r8_BFdxy0rkwAsLaQyof9WQYgpvrp8YyVsw4zs4&usqp=CAU"  // Replace with your birthday background image path
                                                            className="img-fluid rounded-3"
                                                            alt="Birthday Background"
                                                        />
                                                        <span
                                                            className="badge bg-secondary position-absolute top-0 start-0 m-2"
                                                            style={{ transform: 'rotate(-10deg)' }}
                                                        >
                                                            {s.name.toUpperCase()}
                                                        </span>
                                                    </div>

                                                    <div className="card-body text-center">
                                                        <p className="text-muted small mt-2">CELEBRATE A SPECIAL DAY</p>
                                                        <h5 className="fw-bold text-dark mb-2">HAPPY BIRTHDAY TO YOU!</h5>
                                                        <p className="text-muted">Wishing you joyful moments</p>
                                                        <p className="fw-bold mb-0">🎂 DOB: {s.dob}</p>

                                                        <div className="mt-3 d-flex justify-content-center flex-wrap gap-3">
                                                            <button
                                                                className="btn btn-success btn-md px-4 d-flex align-items-center gap-2"
                                                                onClick={() => alert(genMessage(s.name))}
                                                            >
                                                                🎁 Generate Message
                                                            </button>

                                                            <button className="btn btn-primary btn-md px-4 d-flex align-items-center gap-2">
                                                                ✉️ Send Wishes
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Upcoming Birthday Table */}
                                {upcomingList.length > 0 && (
                                    <div className="card">
                                        <div className="card-header bg-info text-white fw-bold">
                                            Upcoming Birthdays (Next 7 Days)
                                        </div>
                                        <div className="card-body p-0">
                                            <div className="table-responsive">
                                                <table className="table table-hover m-0">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Name</th>
                                                            <th>DOB</th>
                                                            <th>Days Left</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {upcomingList.map((s, index) => {
                                                            const today = new Date();
                                                            const birthday = new Date(`${today.getFullYear()}-${formatMD(s.dob)}`);
                                                            const daysLeft = Math.ceil((birthday - today) / (1000 * 60 * 60 * 24));
                                                            return (
                                                                <tr key={s.id}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{s.name}</td>
                                                                    <td>{s.dob}</td>
                                                                    <td>{daysLeft} days</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* No birthdays */}
                                {!todayList.length && !upcomingList.length && (
                                    <div className="alert alert-warning mt-3">
                                        No upcoming birthdays in the next 7 days.
                                    </div>
                                )}

                                <Footer />
                                <div className="content-backdrop fade"></div>
                            </div>
                        </div>
                        <div className="layout-overlay layout-menu-toggle"></div>
                        <div className="drag-target"></div>
                    </div>
                </div>
            </div>
        </>
    );
}
